import { render, staticRenderFns } from "./VatSelection.vue?vue&type=template&id=8de4feee&scoped=true"
import script from "./VatSelection.vue?vue&type=script&lang=js"
export * from "./VatSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de4feee",
  null
  
)

export default component.exports